import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditableTableModule } from './editable-table/editable-table.module';
import { TestingComponent } from './testing/testing.component';


export class AppModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    EditableTableModule
  ],
  declarations: [
    TestingComponent
  ],
  bootstrap: [TestingComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
